import { render } from "./ProfileCard.component.vue?vue&type=template&id=bea80720"
import script from "./ProfileCard.component.vue?vue&type=script&lang=js"
export * from "./ProfileCard.component.vue?vue&type=script&lang=js"

import "./ProfileCard.component.vue?vue&type=style&index=0&id=bea80720&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__